export default "__VITE_ASSET__QW54l7Kt__"